module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10183.db20f279.jpg";